import { React, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

const VerifyShell = ({setMessage, setPageValid, setLoading, endpoint = "/", setIgnore, setData}) => {
    const params = useParams();
    const fetcher = useRef(null);

    useEffect(() => {
        const { protocol, hostname} = window.location;

        if(!fetcher.current) {
            fetcher.current = fetch(`${protocol}//${hostname}${(hostname === "localhost") ? ":3001" : ""}/routes/api/verification/verify${endpoint}`, {
                method: "POST",
                headers: {
                    Accepts: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({data: params.token})
            })
            .then(res => {
                if(res.ok) {
                    return res.json();
                }
    
                throw new Error();
            })
            .then(data => {
                if(data?.type === "success") {
                    if(setMessage) {
                        setMessage(data?.message);
                    }
                }
    
                if(setData) {
                    setData(data);
                }

                if(setIgnore) {
                    setIgnore(true);
                }

                console.log(data);
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
                if(setData) {
                    setData(err);
                }

                if(setIgnore) {
                    setIgnore(true);
                }

                setPageValid(false);
                setLoading(false);
            });
        }
    }, []);
};

export default VerifyShell;